<template>
  <Layout
    :title="title"
    :items="items"
  >
    <b-button
      variant="primary"
      class="mb-4 shadow-sm d-none"
      style="border-radius: 5px;"
    >
      <i class="mdi mdi-arrow-left" />
      Back to Smart Campus
    </b-button>
    <div class="w-md-50 px-3 px-md-0">
      <div
        class="glass"
        style="border-left: 6px solid white; padding: 0.8rem 0.75rem; border-end-end-radius: 3rem;"
      >
        <h1 class="text-white mb-0">
          Smart Water
        </h1>
        <h1 class="text-white mb-0">
          Management System
        </h1>
      </div>
      <div
        class="mt-2 text-white"
        style="font-size: 14px; font-weight: 400"
      >
        Towards smart water management by leveraging the Internet of Things (IoT) technology.
        <br>
        Promoting resilient and efficient water supply system and improving sustainability.
      </div>
      <OrganizationSelector />
    </div>
    <div
      class="position-absolute px-3 px-md-0"
      style="bottom: 5rem;"
    >
      <div
        class="glass"
        style="padding: 0.9rem 0.75rem; border-end-end-radius: 3rem;"
      >
        <div
          class="mb-2 text-white"
          style="font-size: 16px; font-weight: 400"
        >
          Sustainable Development Goals
        </div>

        <img
          :src="require(`@/assets/images/sdg-1.jpeg`)"
          class="img img-fluid pe-2"
          style="max-height: 64px"
        >
        <img
          :src="require(`@/assets/images/sdg-2.jpeg`)"
          class="img img-fluid"
          style="max-height: 64px"
        >
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config';
import Layout from '@/layouts/main';
import OrganizationSelector from '@/components/OrganizationSelector.vue';

export default {
  name: 'Home',
  page: {
    title: 'Home',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout, OrganizationSelector,
  },
  data() {
    return {
      title: 'Home',
      items: [
        {
          text: 'Home',
          active: true,
        },
      ],
    };
  },
  computed: {
    selectedOrganization() {
      return this.$store.state.organization.selectedOrganization;
    },
  },
};
</script>

<style lang="scss" scoped>
.glass {
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
}
</style>
